import React from 'react';
import { ReactComponent as Profile } from '../../../../../_asset/img/profile.svg';
import TimerStart from '../../../../../_asset/img/timer-start.svg';

const OfficerPayout = ({ groupedShifts, providerCompanyId, job }) => {
  const handlePayOfficer = (officerName, totalPayout) => {
    // Handle pay officer action
    console.log(`Paying ${officerName}: $${totalPayout.toFixed(2)}`);
  };

  const handleViewDetails = (officerName) => {
    // Handle view details action
    console.log(`Viewing details for ${officerName}`);
  };

  return (
    <div className="mb-6">
      <h3 className="text-sm font-medium text-black mb-4">Officer Payouts</h3>
      
      {Object.entries(groupedShifts).map(([officerName, officerData]) => (
        <div key={officerName} className="rounded-lg border border-[#E4E4E4] mb-4 overflow-hidden"
             style={{ backgroundColor: '#FFFFFF' }}>
          
          {/* Officer Header */}
          <div className="p-4 border-b border-[#E4E4E4]" style={{ backgroundColor: '#F7F8FA' }}>
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0" 
                     style={{ backgroundColor: '#404880' }}>
                  {officerData.profilePicture ? (
                    <img
                      className="w-8 h-8 rounded-full object-cover"
                      src={officerData.profilePicture}
                      alt="Profile"
                    />
                  ) : (
                    <Profile className="w-4 h-4 text-white" />
                  )}
                </div>
                <div>
                  <h4 className="text-sm font-medium text-black">{officerName}</h4>
                  <p className="text-xs text-[#878787]">{officerData.email}</p>
                </div>
              </div>
              
              <div className="flex items-center gap-3">
                <div className="text-right">
                  <div className="text-lg font-bold text-black">
                    ${officerData.totalPayout.toFixed(2)}
                  </div>
                  <p className="text-xs text-[#878787]">Total Payout</p>
                </div>
                
                {/* Status Badge */}
                <div className="px-3 py-1 rounded-full text-xs font-medium"
                     style={{ 
                       backgroundColor: officerData.status === 'completed' ? '#CCE1D1' : '#FBE7D2',
                       color: officerData.status === 'completed' ? '#82B376' : '#F2A366'
                     }}>
                  {officerData.status === 'completed' ? 'Completed' : 'Pending'}
                </div>
              </div>
            </div>
          </div>

          {/* Shifts Details */}
          <div className="p-4">
            <div className="space-y-3">
              {officerData.shifts.map((shift, index) => (
                <div key={index} className="flex items-center justify-between py-2 border-b border-[#F0F0F0] last:border-b-0">
                  <div className="flex items-center gap-2">
                    <img src={TimerStart} alt="Timer" className="w-4 h-4" />
                    <div>
                      <p className="text-xs font-medium text-black">
                        {new Date(shift.startTime).toLocaleDateString()} - {new Date(shift.startTime).toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'})} to {new Date(shift.endTime).toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'})}
                      </p>
                      <p className="text-xs text-[#878787]">
                        Duration: {((new Date(shift.endTime) - new Date(shift.startTime)) / (1000 * 60 * 60)).toFixed(1)}h
                      </p>
                    </div>
                  </div>
                  
                  <div className="text-right">
                    <div className="text-sm font-medium text-black">
                      ${shift.payout ? shift.payout.toFixed(2) : '0.00'}
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Action Buttons */}
            <div className="flex items-center justify-between mt-4 pt-4 border-t border-[#E4E4E4]">
              <button 
                onClick={() => handleViewDetails(officerName)}
                className="text-xs font-medium px-3 py-2 rounded-lg border border-[#E4E4E4] transition-colors hover:bg-[#F7F8FA]"
                style={{ color: '#404880' }}
              >
                View Details
              </button>
              
              {officerData.status === 'completed' && (
                <button 
                  onClick={() => handlePayOfficer(officerName, officerData.totalPayout)}
                  className="text-white text-xs font-medium px-4 py-2 rounded-lg transition-colors hover:opacity-80"
                  style={{ backgroundColor: '#404880' }}
                >
                  Pay Officer
                </button>
              )}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default OfficerPayout;
